import { Stack, Tooltip, Typography } from '@rossum/ui/material';

export const ColumnHeader = ({
  name,
  typeLabel,
}: {
  name: string;
  typeLabel: string;
}) => (
  // A custom header drops the grid's tooltip for truncated names; restore it.
  <Tooltip title={name} placement="top">
    <Stack minWidth={0}>
      <Typography variant="body2" fontWeight="fontWeightBold" noWrap>
        {name}
      </Typography>
      <Typography variant="caption" color="text.secondary" noWrap>
        {typeLabel}
      </Typography>
    </Stack>
  </Tooltip>
);
